/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_SeoInputs */

const vi_media_field_seo = /** @type {(inputs: Media_Field_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh chia sẻ (SEO)`)
};

/**

* @param {Media_Field_SeoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_seo = /** @type {((inputs?: Media_Field_SeoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_SeoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_seo(inputs)
});